<div *transloco="let translate" class="d-flex flex-column fut-p-16 fut-gap-8 dark-tooltip">
  <div class="d-flex fut-gap-8 align-items-center">
    <app-alice-animations
      *futGhostStateFragment="state(); text: 'XXXX'; paragraph: true"
      class="alice-width"
      type="static"
      width="35"
      height="35"></app-alice-animations>
    @if (translatedComment(); as comment) {
      <div *futGhostStateFragment="state(); textMinChar: 50; textMaxChar: 50; paragraph: true" class="m-0">
        @if (comment.translate) {
          <ng-container *transloco="let translate; scope: comment.scope || ''">
            <span [innerHTML]="translate(comment.text, comment.translateArgs)"></span>
          </ng-container>
        } @else {
          <span [innerHTML]="comment.text"></span>
        }
      </div>
    }
  </div>
  <ng-content></ng-content>
</div>
